/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeReportViewCtrl
 */
angular.module('mercury.modules.stock.stocktakereport')
.controller('StockStocktakeReportViewCtrl', ["dialog", "$filter", "$scope", "$state", "$stateParams", "StocktakeReports", "title", function(dialog, $filter, $scope, $state, $stateParams, StocktakeReports, title) {
  title.set('Stocktake Report');

  $scope.report = StocktakeReports.stocktakeReport($stateParams.startStocktake, $stateParams.endStocktake);

  $scope.report.then(function(report) {
    $scope.groups = [];

    var closingStockOnHand = 0;

    angular.forEach(report.lines, function(line) {
      if (line.groupHeader) {
        $scope.groups.push({
          header: line.groupHeader,
          lines: []
        });
      } else {
        line.usedQty = line.startQty + line.qtyReceived - line.endQty;
        line.usedCost = line.usedQty * line.unitCost;
        line.variance = line.expectedUsed - line.usedQty;
        line.varianceCost = line.variance * line.unitCost;

        closingStockOnHand += line.endQty * line.unitCost;

        $scope.groups[$scope.groups.length - 1].lines.push(line);
      }
    });

    angular.forEach($scope.groups, function(group) {
      group.usedCost = $filter('sumof')(group.lines, 'usedCost');
      group.varianceCost = 0;
      angular.forEach(group.lines, function(groupLine) {
        if (groupLine.hasPosLinks) {
          group.varianceCost += groupLine.varianceCost;
        }
      });
    });

    $scope.reportUsedCost = $filter('sumof')($scope.groups, 'usedCost');
    $scope.reportVarianceCost = $filter('sumof')($scope.groups, 'varianceCost');

    $scope.report = report;

    // guess the discount sales tax based on the total sales tax
    var totalTaxRate = report.totalSalesEx === 0 ? 0 : (report.totalSales - report.totalSalesEx) / report.totalSalesEx;
    report.totalDiscountEx = report.totalDiscount / (1 + totalTaxRate);

    $scope.cogsPreDiscount = ($scope.reportUsedCost / (report.totalSalesEx + report.totalDiscountEx)) * 100;
    $scope.cogsPostDiscount = ($scope.reportUsedCost / report.totalSalesEx) * 100;
    $scope.varianceCogs = $scope.cogsPreDiscount - $scope.cogsPostDiscount;

    var weekDifference = moment(report.startTime).diff(report.endTime, 'days') / 7;
    $scope.weeksRemainingStock = (closingStockOnHand / $scope.reportUsedCost) * weekDifference;
  }, function() {
    $state.go('Stock.StocktakeReport');
  });

  $scope.showReceived = function(reportLine) {
    $state.go('.Received',
      {itemId: reportLine.stockItemId, startTime: $scope.report.startDate, endTime: $scope.report.endDate},
      {location: 'replace'});
  };

  $scope.showCalculatedUsage = function(reportLine) {
    $state.go('.CalculatedUsage',
      {
        itemId: reportLine.stockItemId,
        startTime: $scope.report.startDate,
        endTime: $scope.report.endDate,
        unitName: reportLine.unit.name,
        unitRatio: reportLine.unit.ratio
      },
      {location: 'replace'});
  };

  $scope.showPriceBox = function(reportLine, quantity) {
    $state.go('.StockPrice',
      {itemId: reportLine.stockItemId, quantity: quantity, unitName: reportLine.unit.name, unitRatio: reportLine.unit.ratio, dateFor: $scope.report.endDate},
      {location: 'replace'});
  };
}]);
